import { render } from "./ProductSellerInfo.vue?vue&type=template&id=5b4cc2ba&ts=true"
import script from "./ProductSellerInfo.vue?vue&type=script&lang=ts"
export * from "./ProductSellerInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__